module.exports = __webpack_public_path__ + "img/arthouse.1e1c6d6.webp";